import authService from '../../../utils/authService';

export interface SessionSummaryBasic {
  live_session_id: string;
  session_name: string | null;
  date: string | null;
  start: string | null;
  end: string | null;
  duration_minutes: number | null;
  duration_label: string;
  invitees: number;
  attended: number;
  attendance_percent: number | null;
  subject: string | null;
  topics: string[];
}

export interface TierPercents {
  high_percent: number | null;
  medium_percent: number | null;
  low_percent: number | null;
}

export interface SessionSummaryResponse {
  success: boolean;
  basic: SessionSummaryBasic;
  grasping: {
    understood_percent: number | null;
    partial_percent: number | null;
    did_not_percent: number | null;
  };
  feedback: TierPercents;
  quiz_scores: TierPercents;
  engagement: {
    questions_raised: number;
    qa_duration_minutes: number | null;
    qa_duration_label: string;
    doubts_raised: number;
    doubts_resolved: number;
  };
  distraction: {
    students_distracted: number;
    distracted_duration_students_percent: number | null;
    distracted_duration_class_percent: number | null;
  };
}

export interface SessionOption {
  session_id: string;
  session_title: string;
  session_type?: string | null;
}

export interface AttendanceReportSessions {
  Session_title_dict?: Record<string, string>;
  Session_options?: SessionOption[];
}

export async function fetchSessionSummary(
  sessionId: string,
): Promise<SessionSummaryResponse> {
  const response = await authService.get(
    `coordinator/session-summary/${encodeURIComponent(sessionId)}/`,
  );
  return response.data as SessionSummaryResponse;
}

export async function fetchCoordinatorSessions(payload: {
  course_name: string;
  batch_name: string;
  user_id: string;
  subject_name?: string;
}): Promise<AttendanceReportSessions> {
  const response = await authService.post('/coordinator/attendance_report/', payload);
  return response.data as AttendanceReportSessions;
}
